import { app, Component } from 'apprun';
import AgentAboutForm from './template/agent-about-template';

export default class AgentAbout extends Component {
  view = (state) => {
    return (
      <AgentAboutForm agent={state.agent} />
    );
  };

  update = {
    '/setComponentState': (_, { agent }) => {
      return { agent };
    }
  };
}
